import React from 'react';

import { LancamentosView } from '../components/LancamentosView';

export const FinanceiroContasPagarPage = () => <LancamentosView tipo="DESPESA" />;
